import React from "react";

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { key: "incidentManagement", label: "Incident Management", url: "?tab=incidents" },
    { key: "accessManagement", label: "Access Management", url: "?tab=access-management" },
  ];

  return (
    <div className="flex space-x-2 mb-4 bg-white w-[400px]">
      {tabs.map(({ key, label, url }) => (
        <a
          key={key}
          href={url}
          className={
            activeTab === key
              ? "bg-[#bb1ccc] text-white text-[14px] rounded-md px-4 py-2"
              : "bg-white text-gray-500 text-[14px] rounded-md px-4 py-2"
          }
          onClick={(e) => {
            e.preventDefault();
            setActiveTab(key);
          }}
        >
          {label}
        </a>
      ))}
    </div>
  );
};

export default Tabs;